import type { GlobalState } from '../types';

import { DEFAULT_FORENSIC_SETTINGS, DEFAULT_RASITECH_MODULES, DEFAULT_RASITECH_SETTINGS } from '../types/sharedState';

export function selectSharedState<T extends GlobalState>(
  global: T,
) {
  return global.sharedState;
}

export function selectSharedSettings<T extends GlobalState>(
  global: T,
) {
  return selectSharedState(global).settings;
}

export function selectAnimationLevel<T extends GlobalState>(
  global: T,
) {
  return selectSharedSettings(global).animationLevel;
}

export function selectRasiTechSettings<T extends GlobalState>(
  global: T,
) {
  return {
    ...DEFAULT_RASITECH_SETTINGS,
    ...selectSharedSettings(global).rasiTech,
  };
}

export function selectForensicSettingsFromShared<T extends GlobalState>(
  global: T,
) {
  return {
    ...DEFAULT_FORENSIC_SETTINGS,
    ...selectSharedSettings(global).forensic,
  };
}

export function selectRasiTechModules<T extends GlobalState>(global: T) {
  const modules = selectSharedSettings(global).rasiTechModules;
  return {
    ...DEFAULT_RASITECH_MODULES,
    ...modules,
    privateMode: { ...DEFAULT_RASITECH_MODULES.privateMode, ...modules?.privateMode },
    customizations: { ...DEFAULT_RASITECH_MODULES.customizations, ...modules?.customizations },
    extraButtons: { ...DEFAULT_RASITECH_MODULES.extraButtons, ...modules?.extraButtons },
    webhooks: { ...DEFAULT_RASITECH_MODULES.webhooks, ...modules?.webhooks },
    smartReply: { ...DEFAULT_RASITECH_MODULES.smartReply, ...modules?.smartReply },
    broadcast: { ...DEFAULT_RASITECH_MODULES.broadcast, ...modules?.broadcast },
  };
}
